import { render, staticRenderFns } from "./RegionHeader.vue?vue&type=template&id=dc6e94c0&scoped=true&"
import script from "./RegionHeader.vue?vue&type=script&lang=ts&"
export * from "./RegionHeader.vue?vue&type=script&lang=ts&"
import style0 from "./RegionHeader.vue?vue&type=style&index=0&id=dc6e94c0&lang=less&scoped=true&"
import style1 from "./RegionHeader.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6e94c0",
  null
  
)

export default component.exports